module.exports = __webpack_public_path__ + "static/media/elder-turban.5e001bb8.png";